exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes spinner-line-fade-more{0%,to{opacity:0}1%{opacity:1}}@keyframes spinner-line-fade-quick{0%,39%,to{opacity:.25}40%{opacity:1}}@keyframes spinner-line-fade-default{0%,to{opacity:.22}1%{opacity:1}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/spin.js/spin.css
// module id = 75
// module chunks = 1